/** Brief 12, `Bosh sahifa`. */
export const uzB12Home = {
  "home.greet.morning": "Xayrli tong",
  "home.greet.day": "Xayrli kun",
  "home.greet.evening": "Xayrli kech",
  "home.time.minutes": "{count} daq",
  "home.time.hours": "{count} soat",
  "home.time.days": "{count} kun",
  "home.time.ago": "{duration} oldin",
  "home.when.today": "Bugun",
  "home.when.yesterday": "Kecha",
  "home.when.tomorrow": "Ertaga",
  "home.wait.since": "{duration}dan beri javobsiz",
  "home.summary.operator": "Bugun {tasks} ta vazifa va {waiting} ta mijozga javob berish qoldi.",
  "home.summary.operatorCalm": "Hammasi joyida. Bugun {waiting} ta mijozga javob berish qoldi.",
  "home.summary.operatorFirst": "Eng muhimi: {name} {duration}dan beri javob kutmoqda.",
  "home.summary.important": "Eng muhimi: {count} {text}.",
  "home.summary.decisions": "{count} ta qaror sizni kutmoqda.",
  "home.summary.finance": "Bugun {clients} ta mijoz to'lovi va {providers} ta operatorga to'lov muddati bor.",
  "home.empty.title": "Hammasi joyida",
  "home.empty.message": "Bugun javob kutayotgan mijoz va muddati kelgan vazifa yo'q. Yangisi kelsa, shu yerda ko'rinadi.",
  "home.empty.action": "Suhbatlarga",
  "home.empty.finance": "Bugun kutilayotgan to'lov va operatorga to'lov muddati yo'q. Yangisi kelsa, shu yerda ko'rinadi.",
  "home.empty.financeAction": "Moliyaga",
  "home.error.title": "Bosh sahifa yuklanmadi",
  "home.error.message": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "home.error.code": "Xato {status} · {time}",
  "home.error.offline": "Tarmoq xatosi · {time}",
  "home.error.status": "Tizim holati",
  "home.denied.message": "Bu rol bosh sahifani ko'rmaydi. Kerak bo'lsa, agentlik egasiga yozing.",
  "home.tasks.title": "Bugungi vazifalar",
  "home.tasks.count": "{count} ta",
  "home.tasks.all": "Hammasi",
  "home.tasks.tier.overdue": "Muddati o'tgan",
  "home.tasks.tier.today": "Bugun",
  "home.tasks.tier.next": "Keyingi",
  "home.tasks.done": "Bajarildi",
  "home.tasks.doneToast": "Bajarildi: {title}",
  "home.tasks.failed": "Vazifani yopib bo'lmadi: {reason}",
  "home.tasks.allDone": "Bugun hammasi bajarildi",
  "home.tasks.allDoneHint": "Yangi vazifa kelsa, shu yerda ko'rinadi.",
  "home.task.instalment": "{amount} qoldiq eslatmasi",
  "home.action.thread": "Suhbatni ochish",
  "home.kind.call": "Qo'ng'iroq",
  "home.kind.reply": "Xabar",
  "home.kind.follow_up": "Qayta aloqa",
  "home.kind.collect_payment": "To'lov",
  "home.kind.request_document": "Hujjat",
  "home.kind.request_review": "Sharh",
  "home.kind.other": "Vazifa",
  "home.waiting.title": "Javob kutmoqda",
  "home.waiting.link": "Suhbatlarga",
  "home.waiting.aiOff": "AI o'chiq",
  "home.waiting.empty": "Javob kutayotgan mijoz yo'q.",
  "home.results.title": "Mening natijam",
  "home.results.period": "bu hafta",
  "home.results.sales": "Sotuvlar",
  "home.results.conversion": "Konversiya",
  "home.results.firstResponse": "Birinchi javob",
  "home.results.few": "kamida {minimum} ta lid kerak",
  "home.results.report": "Mening hisobotim",
  "home.tip.label": "Kapitan AI · maslahat",
  "home.tip.prepare": "Taklif tayyorlash",
  "home.tip.laterToast": "Ertaga yana eslatamiz",
  "home.near.deal": "Bitim №{number}",
  "home.problem.tag.noOffer": "Taklif",
  "home.problem.tag.unanswered": "Javobsiz",
  "home.problem.tag.idle": "Harakatsiz",
  "home.problem.noOffer": "ta mijozga taklif yuborilmagan",
  "home.problem.unanswered": "suhbat {hours} soatdan beri javobsiz",
  "home.problem.idle": "bitim {days} kundan beri harakatsiz",
  "home.problem.list": "Ro'yxat",
  "home.problem.see": "Ko'rish",
  "home.alert.title": "{branch}: {count} ta murojaat {minutes} daqiqadan beri javobsiz",
  "home.alert.longest": "Eng uzog'i {minutes} daqiqa.",
  "home.alert.names": "{names} kutmoqda.",
  "home.alert.away": "Filialda {count} operator «Ishda emas» holatida.",
  "home.alert.distribute": "Navbatni taqsimlash",
  "home.alert.done": "Navbat taqsimlandi · {names}",
  "home.alert.nothing": "Taqsimlanadigan suhbat yo'q: hammasi biriktirilgan yoki filialda ishdagi operator yo'q.",
  "home.alert.failed": "Navbatni taqsimlab bo'lmadi: {reason}",
  "home.decisions.title": "Qaroringiz kerak",
  "home.decisions.empty": "Hamma qarorlar qabul qilindi.",
  "home.decision.discount": "Chegirma",
  "home.decision.reassign": "Biriktirish",
  "home.decision.leave": "Ta'til",
  "home.decision.reassignTitle": "{name} {client} suhbatini olmoqchi",
  "home.decision.because": "Sabab: {reason}",
  "home.decision.holder": "Hozir {name}da.",
  "home.decision.margin": "Marja {margin}% · minimal {min}%",
  "home.decision.approved": "Tasdiqlandi: {title}",
  "home.decision.rejected": "Rad etildi: {title}",
  "home.branch.all": "Barcha",
  "home.kpi.revenue": "Tushum",
  "home.kpi.margin": "Marja",
  "home.kpi.conversion": "Konversiya",
  "home.kpi.average": "O'rtacha chek",
  "home.kpi.currency": "Valyuta",
  "home.kpi.note": "Grafikda joriy 30 kun, kulrang punktir — o'tgan davr.",
  "home.kpi.report": "Operatorlar va filiallar · batafsil hisobot",
  "home.funnel.title": "Voronka",
  "home.funnel.weakest": "{from}dan {to}ga o'tish {rate}%: {base} tadan {lost} tasi shu yerda to'xtagan.",
  "home.directions.other": "Boshqa",
  "home.finance.income": "Bugungi tushum",
  "home.finance.incomeHint": "{count} ta to'lov",
  "home.finance.expected": "Kutilayotgan ({days} kun)",
  "home.finance.expectedHint": "{count} ta mijoz",
  "home.finance.provider": "Operatorlarga to'lov",
  "home.finance.providerSoon": "{count} tasi {days} kun ichida",
  "home.finance.providerHint": "{count} ta bron",
  "home.finance.refunds": "Qaytarishlar",
  "home.finance.refundsHint": "Bu oy · {count} ta storno",
  "home.finance.title": "Bugungi to'lovlar",
  "home.finance.link": "Moliya",
  "home.finance.empty": "Bugun to'lov yo'q",
  "home.finance.col.client": "Mijoz",
  "home.finance.col.deal": "Bitim",
  "home.finance.col.amount": "Summa",
  "home.finance.col.due": "Muddat",
  "home.finance.col.state": "Holat",
  "home.finance.state.expected": "Kutilmoqda",
  "home.finance.state.paid": "To'landi · {via}",
  "home.finance.state.overdue": "Muddati o'tgan",
  "home.finance.state.planned": "Rejada",
} as const;
